import { useEffect } from 'react';

const useFocusOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            const el = ref?.current;
            if (!el || el.contains(event?.target || null)) {
                return;
            }
            // Call the handler only if the focus is outside of the element passed.
            handler(event);
        };
        document.addEventListener('focusin', listener);
        return () => {
            document.removeEventListener('focusin', listener);
        };
    }, [ref, handler]); // Reload only if ref or handler changes
};

export { useFocusOutside };
//# sourceMappingURL=useFocusOutside.js.map
